"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/d9039985-14e7-464a-a345-ffeda01366a7
 * name: MIcInsertList
 */
function MIcInsertList() {
    return null;
}
exports.default = MIcInsertList;
;
